import React, {Component} from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux';

import PostTitle from '../../components/contents/post/PostTitle'
import PostListHeader from '../../components/contents/post/PostListHeader'
import PostList from '../../components/contents/post/PostList'
import Pagination from '../../components/common/Pagination';
import { parseListParams } from '../../components/contents/post/PostListHelper';

@connect(state => ({
    items: state.post.item.items,
    totalCount: state.post.item.totalCount,
    condition: state.post.condition,
}))
class PostApp extends Component {

    render() {

    	const { totalCount } = this.props;

        return (
				<div className="inner_article contents_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<Route path="/posts" exact={false} strict={false} component={PostTitle}/>
					<Route path="/posts" exact={false} strict={false} component={PostListHeader}/>
					<Route path="/posts" exact={false} strict={false} component={PostList}/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
        )
    }
}

export default PostApp;
